// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { ApplicationInfo } from '../../ApplicationInfo';
export class _TVCustomTranslations {
    Translate(key, options, isTranslated) {
        if (key === 'StopLimit') {
            return Resources.getResource('TvTradingPlatform.OrderType.StopLimit');
        }
        if (ApplicationInfo.isExploreMode && key === 'To learn more, please contact your broker.') {
            return '';
        }
        return null;
    }
}
export const TVCustomTranslations = new _TVCustomTranslations();
